import React, { useEffect, useRef, useState } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const Tooltip = function ({ tooltipText, fields }) {
  const tooltipRef = useRef(null);
  const [isTooltipActive, setIsTooltipActive] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const toggleTooltip = event => {
    event.stopPropagation();
    setIsTooltipActive(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = e => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setIsTooltipActive(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const mobileWidth = 768;
    const checkMobile = () => setIsMobile(window.innerWidth <= mobileWidth);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <span
      className={`vds-tooltip vds-form__label-tooltip${
        isTooltipActive ? ' vds-tooltip--active' : ''
      }`}
      role="tooltip"
      aria-expanded={isTooltipActive}
    >
      <button
        type="button"
        className="vds-tooltip__trigger vds-tooltip__trigger--icon"
        onClick={toggleTooltip}
        data-testid={
          fields?.testid?.value ? `${fields?.testid?.value}-tooltip-trigger` : 'tooltip-trigger'
        }
      ></button>

      <span className="vds-tooltip__text" aria-hidden={!isTooltipActive} aria-live="polite">
        <span className="vds-tooltip__text-inner" ref={tooltipRef}>
          <Text field={tooltipText} />
          <button
            type="button"
            className={`vds-tooltip__close ${!isMobile ? 'vds-tooltip__close--hidden' : ''}`}
            onClick={() => setIsTooltipActive(false)}
            data-testid={
              fields?.testid?.value ? `${fields?.testid?.value}-tooltip-close` : 'tooltip-close'
            }
          />
        </span>
      </span>
    </span>
  );
};

export default Tooltip;
